// Wire shapes for GET /catalog/items — must mirror Catalog::Product and
// CatalogItemsController (app/services/catalog.rb). The type list mirrors
// Catalog::PRODUCT_TYPES: the flooring classes offered in the picker.

export type CatalogItem = {
  id: string
  style: string | null
  color: string | null
  product_type: string | null
  format_label: string | null
  unit: string | null
  sqft_per_carton: number | null
  roll_width_ft: number | null
  vendor_name: string | null
  active: boolean
  /** Unit cost per the item's own unit — prefill/display only; authoritative
      cost seeding stays server-side. */
  vendor_cost: number | null
  /** Freight per the item's own unit — same prefill/display-only contract. */
  freight_cost: number | null
}

export type CatalogSearchResponse = {
  available: boolean
  items: CatalogItem[]
}

export const PRODUCT_TYPES = [
  "Tile",
  "Carpet",
  "Carpet Tile",
  "Wood",
  "LVP",
  "Laminate",
  "Sheet Vinyl",
  "Natural Stone",
  "Deco",
] as const

/** What the ADD-ON picker may reach — mirrors Catalog::ADD_ON_TYPES: the
    flooring classes plus Misc (pad, setting materials, trim). Labor and
    Other Charge stay out — those are bid-line concerns. */
export const ADD_ON_TYPES = [...PRODUCT_TYPES, "Misc"] as const

/** What an order-template line may reference — mirrors Catalog::BID_LINE_TYPES:
    everything above plus Labor and Other Charge (M9's money unlock). */
export const BID_LINE_TYPES = [...ADD_ON_TYPES, "Labor", "Other Charge"] as const

/** Roll goods get no pattern in M5 — seam planning is milestone 7. */
export const ROLL_GOOD_TYPES = new Set(["Carpet", "Sheet Vinyl"])

/** Plank goods default to random stagger. */
export const PLANK_TYPES = new Set(["Wood", "LVP", "Laminate"])
